<style>

  .front-image {
    width: 100%;
    height: 300px;
    background: rgb(248, 249, 251);
    margin-left: auto;
    margin-right: auto;
  }

  @media (min-width: 728px) {
    .front-image {
      width: 728px;
    }
  }

  @media (min-width: 1092px) {
    .front-image {
      width: 1092px;
    }
  }

  .front-image img {
    object-fit: cover;
    object-position: bottom;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
</style>

<div class="front-image">
<!--  <img async id="front-image" on:load={onImageLoad} alt="Ladenfront" src="images/front-1920.jpg"-->
<!--       srcset="images/front-1920.jpg 1920w, images/front-1200.jpg 1200w, images/front-720.jpg 720w"/>-->
  <img async id="front-image" on:load={onImageLoad} alt="Ladenfront" src="images/teleklinik.jpg"/>
</div>

<script>
  function onImageLoad() {
    document.getElementById('front-image').classList += ' fadeIn';
  }
</script>
